import { useFormikContext } from "formik";
import { FloatingLabel, Form } from "react-bootstrap";
import { MonerisConfiguration } from "../../models";

export const MonerisConfigurationForm = () => {
  interface FormValues {
    name: string; 
    configuration: MonerisConfiguration;
  }
  const { values, handleChange, errors, touched } = useFormikContext<FormValues>();
  return (
    <div className="row">
      <div className="col col-24 mb-3">
        <FloatingLabel label="Store ID">
          <Form.Control
            name="configuration.storeId"
            value={values.configuration.storeId || ""}
            onChange={handleChange}
            isInvalid={!!errors.configuration?.storeId && !!touched.configuration?.storeId}
          />
        </FloatingLabel>
        <Form.Control.Feedback type="invalid">
          {errors.configuration?.storeId}
        </Form.Control.Feedback>
        <FloatingLabel label="API Token" className="mt-2">
          <Form.Control
            name="configuration.apiToken"
            value={values.configuration.apiToken || ""}
            onChange={handleChange}
            isInvalid={!!errors.configuration?.apiToken && !!touched.configuration?.apiToken}
          />
        </FloatingLabel>
        <Form.Control.Feedback type="invalid">
          {errors.configuration?.apiToken}
        </Form.Control.Feedback>
      </div>
    </div>
  )
}

export default MonerisConfigurationForm;
